import React, { useState, useEffect } from 'react';
import './CreativeBriefForm.css';
import ProgressLoader from './ProgressLoader';
import Sidebar from './Sidebar';
import { HiDownload } from 'react-icons/hi';
import { FiEye, FiVideo } from 'react-icons/fi';

const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan',
  'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi',
  'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia',
  'Fiji', 'Finland', 'France',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary',
  'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan',
  'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan',
  'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar',
  'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway',
  'Oman',
  'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
  'Qatar',
  'Romania', 'Russia', 'Rwanda',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria',
  'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan',
  'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
  'Yemen',
  'Zambia', 'Zimbabwe'
];

const INDUSTRIES = [
  'E-commerce / Online Shopping',
  'Fashion & Apparel',
  'Footwear',
  'Beauty & Personal Care',
  'Health & Wellness',
  'Fitness / Sports & Outdoors',
  'Electronics & Gadgets',
  'Mobile Apps / SaaS',
  'Fintech / Banking / Insurance',
  'Edtech / Online Learning',
  'Food Delivery / Restaurants',
  'Travel & Hospitality',
  'Real Estate',
  'Automobiles / Mobility',
  'Home & Living / Furniture',
  'Grocery / Quick Commerce',
  'Gaming',
  'Entertainment / OTT / Media',
  'Telecom / Internet Services',
  'B2B / Enterprise Solutions',
  'Others'
];

const BRAND_PERSONALITIES = [
  'Premium',
  'Mass-market / Value for Money',
  'Fun & Playful',
  'Bold & Edgy',
  'Minimal & Modern',
  'Traditional / Heritage',
  'Trustworthy / Reliable',
  'Youthful',
  'Family-friendly',
  'Innovative / Tech-forward',
  'Aspirational / Luxurious',
  'Professional / Serious',
  'Quirky / Offbeat',
  'Warm & Caring',
  'Eco-conscious / Sustainable'
];

const CAMPAIGN_GOALS = [
  'Brand Awareness / Reach',
  'Video Views',
  'Traffic (Website / Landing Page Visits)',
  'App Installs',
  'Lead Generation (Form Fills)',
  'Add to Cart / Product Page Views',
  'Purchases / Sales / Conversions',
  'Repeat Purchases / Retention',
  'Store Visits / Offline Footfall',
  'Engagement (Likes, Comments, Shares)',
  'Other'
];

const AGE_GROUPS = ['13-17', '18-24', '25-34', '35-44', '45-54', '55+'];

const GENDERS = ['All', 'Male', 'Female', 'Other / Non-binary', 'Custom'];

const AUDIENCE_TYPES = [
  'New Users / Prospecting',
  'Retargeting – Website Visitors',
  'Retargeting – App Users',
  'Retargeting – Add to Cart, No Purchase',
  'Retargeting – Past Purchasers',
  'High-Value / Loyal Customers',
  'Lookalike of Converters / Purchasers',
  'Lookalike of Website Visitors',
  'CRM List / Custom List',
  'Interest-based Audience',
  'Contextual / Content-based Audience',
  'Other'
];

const OFFER_TYPES = [
  'No Offer / Always-On Campaign',
  'Flat Discount (%)',
  'Flat Discount (Value)',
  'Tiered Discount',
  'Cashback',
  'Free Shipping',
  'Buy X Get Y',
  'Free Trial / Demo',
  'Introductory Offer / Launch Offer',
  'Seasonal Sale',
  'EMI / No-Cost EMI / Financing',
  'Loyalty / Referral Rewards',
  'Other'
];

const CREATIVE_OBJECTIVES = [
  'Drive Clicks to Website / App Store',
  'Drive App Installs',
  'Drive Product Page Visits',
  'Drive Purchases / Transactions',
  'Drive Form Fills / Leads',
  'Drive Store Visits',
  'Drive Video Views / Completion',
  'Drive Engagement',
  'Drive Add to Cart / Wishlist',
  'Educate about New Feature / Launch',
  'Promote Limited-time Offer / Sale',
  'Other'
];

const CREATIVE_FORMATS = [
  { value: '1080x1080', label: '1:1 (Square Feed/Carousel)' },
  { value: '1080x1350', label: '4:5 (Vertical Feed)' },
  { value: '1080x1920', label: '9:16 (Stories/Reels)' },
  { value: '1920x1080', label: '1.91:1 (Landscape Feed)' }
];

const COMMON_FONTS = [
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Georgia',
  'Verdana',
  'Courier New',
  'Trebuchet MS',
  'Comic Sans MS',
  'Impact',
  'Lucida Sans',
  'Tahoma',
  'Palatino',
  'Garamond',
  'Bookman',
  'Avant Garde',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Raleway',
  'Poppins',
  'Nunito',
  'Playfair Display',
  'Merriweather',
  'Source Sans Pro',
  'Inter',
  'SF Pro Display',
  'Segoe UI',
  'Ubuntu',
  'Proxima Nova'
];

const FONT_USAGE_TYPES = [
  'Primary',
  'Secondary'
];

function CreativeBriefForm() {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

  // Helper function to get the full image URL
  const getImageUrl = (imageUrl) => {
    // If imageUrl is already a full URL (GCS URL), return as-is
    if (imageUrl && (imageUrl.startsWith('http://') || imageUrl.startsWith('https://'))) {
      return imageUrl;
    }
    // Otherwise, prepend API_URL for local/relative paths
    return `${API_URL}${imageUrl}`;
  };

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);

  // Step 1: Mandatory fields
  const [brandName, setBrandName] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [referenceAds, setReferenceAds] = useState([]);
  const [referenceAdUrls, setReferenceAdUrls] = useState('');
  const [isProductAd, setIsProductAd] = useState(false);
  const [productImage, setProductImage] = useState(null);
  const [country, setCountry] = useState('');

  // Product analysis data from Step 1
  const [productAnalysis, setProductAnalysis] = useState(null);
  const [productImagePath, setProductImagePath] = useState(null);
  const [brandLogoPath, setBrandLogoPath] = useState(null);

  // Brand Guidelines from Step 1
  const [colorPalette, setColorPalette] = useState([]);
  const [fonts, setFonts] = useState([]);
  const [contentGuidelines, setContentGuidelines] = useState('');

  // Brand Guidelines UI state
  const [guidelinesExpanded, setGuidelinesExpanded] = useState(false);
  const [activeGuidelineTab, setActiveGuidelineTab] = useState('design'); // 'design' or 'content'
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [isFontPickerOpen, setIsFontPickerOpen] = useState(false);
  const [isEditingContent, setIsEditingContent] = useState(false);
  const [tempColor, setTempColor] = useState('#3498DB');
  const [tempColorHex, setTempColorHex] = useState('#3498DB');
  const [tempFontFamily, setTempFontFamily] = useState('Arial');
  const [tempFontUsage, setTempFontUsage] = useState('Subheading');
  const [fontSearchQuery, setFontSearchQuery] = useState('');
  const [fontDropdownOpen, setFontDropdownOpen] = useState(false);
  const [hue, setHue] = useState(200);
  const [saturation, setSaturation] = useState(70);
  const [brightness, setBrightness] = useState(85);
  const [isDraggingGradient, setIsDraggingGradient] = useState(false);
  const [showCopyToast, setShowCopyToast] = useState(false);

  // Step 2: Auto-filled & editable fields
  const [industryCategory, setIndustryCategory] = useState('');
  const [brandDescription, setBrandDescription] = useState('');
  const [brandPersonality, setBrandPersonality] = useState([]);
  const [keyCompetitors, setKeyCompetitors] = useState('');
  const [primaryCampaignGoal, setPrimaryCampaignGoal] = useState('');
  const [ageGroups, setAgeGroups] = useState([]);
  const [gender, setGender] = useState('All');
  const [targetLocations, setTargetLocations] = useState('');
  const [languages, setLanguages] = useState('');
  const [audienceType, setAudienceType] = useState([]);
  const [offerType, setOfferType] = useState('');
  const [offerDetails, setOfferDetails] = useState('');
  const [creativeObjective, setCreativeObjective] = useState('');
  const [creativeFormats, setCreativeFormats] = useState(['1080x1080']);
  const [additionalNotes, setAdditionalNotes] = useState('');
  const [numberOfVariants, setNumberOfVariants] = useState(2);

  const [creatives, setCreatives] = useState([]);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);
  const [progressMessage, setProgressMessage] = useState('');
  const [targetProgress, setTargetProgress] = useState(0);

  // Improvement feature states
  const [improvingCreativeIndex, setImprovingCreativeIndex] = useState(null); // Which creative being improved
  const [showImprovementModal, setShowImprovementModal] = useState(false); // Modal open/closed
  const [selectedCreativeForImprovement, setSelectedCreativeForImprovement] = useState(null); // Creative object
  const [currentSessionId, setCurrentSessionId] = useState(null); // Session ID for improvements

  // Text analysis states
  const [analyzingText, setAnalyzingText] = useState(false); // Loading state for analysis
  const [textMetadata, setTextMetadata] = useState(null); // { textElements: [], tokenUsage: {} }
  const [analysisError, setAnalysisError] = useState(null); // Error message

  // Improvement form states
  const [textEdits, setTextEdits] = useState({}); // Map: textIndex → newValue
  const [freeformInstructions, setFreeformInstructions] = useState(''); // Freeform textarea value
  const [improvementLoading, setImprovementLoading] = useState(false); // Loading state for improvement
  const [improvementError, setImprovementError] = useState(null); // Error message
  const [improvementSuccess, setImprovementSuccess] = useState(false); // Success state

  // Video generation states
  const [generateVideos, setGenerateVideos] = useState(false);
  const [videoStyle, setVideoStyle] = useState('simple-ugc');
  const [videoDuration, setVideoDuration] = useState('8');
  const [videoQuality, setVideoQuality] = useState('720p');
  const [generatedVideo, setGeneratedVideo] = useState(null);
  const [resultType, setResultType] = useState(null); // 'images' or 'video'

  // Smooth progress animation
  useEffect(() => {
    if (progress < targetProgress) {
      const increment = Math.max(1, (targetProgress - progress) / 20);
      const timer = setTimeout(() => {
        setProgress(prev => Math.min(prev + increment, targetProgress));
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [progress, targetProgress]);

  // Removed: localStorage auto-restore on mount
  // Form now always starts fresh on page load/reload

  // Removed: localStorage auto-save on field change
  // No longer needed since we don't restore from localStorage

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setReferenceAds(files);
  };

  const handleProductImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProductImage(file);
    }
  };

  const handleBrandLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is SVG
      if (file.name.toLowerCase().endsWith('.svg')) {
        setError('SVG logos are not supported. Please upload PNG, JPG, or WebP format.');
        e.target.value = ''; // Reset input
        return;
      }

      // If we're in Step 2, upload the logo immediately and get the path
      if (step === 2) {
        try {
          const formData = new FormData();
          formData.append('brandLogo', file);

          const response = await fetch(`${API_URL}/upload-logo`, {
            method: 'POST',
            body: formData
          });

          const data = await response.json();
          if (data.logoPath) {
            setBrandLogoPath(data.logoPath);
          }
        } catch (err) {
          console.error('Error uploading logo:', err);
          setError('Failed to upload logo. Please try again.');
        }
      }
    }
  };

  // HSB to Hex conversion
  const hsbToHex = (h, s, b) => {
    s = s / 100;
    b = b / 100;
    const k = (n) => (n + h / 60) % 6;
    const f = (n) => b * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1)));
    const rgb = [f(5), f(3), f(1)].map(x => Math.round(x * 255));
    return '#' + rgb.map(x => x.toString(16).padStart(2, '0')).join('').toUpperCase();
  };

  // Hex to HSB conversion
  const hexToHsb = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    let h = 0;
    if (delta !== 0) {
      if (max === r) h = 60 * (((g - b) / delta) % 6);
      else if (max === g) h = 60 * ((b - r) / delta + 2);
      else h = 60 * ((r - g) / delta + 4);
    }
    if (h < 0) h += 360;

    const s = max === 0 ? 0 : (delta / max) * 100;
    const brightness = max * 100;

    return { h: Math.round(h), s: Math.round(s), b: Math.round(brightness) };
  };

  const handleOpenColorPicker = () => {
    const hsb = hexToHsb('#3498DB');
    setHue(hsb.h);
    setSaturation(hsb.s);
    setBrightness(hsb.b);
    setTempColor('#3498DB');
    setTempColorHex('#3498DB');
    setIsColorPickerOpen(true);
  };

  const updateGradientColor = React.useCallback((clientX, clientY, rect) => {
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const y = Math.max(0, Math.min(clientY - rect.top, rect.height));
    const newSat = (x / rect.width) * 100;
    const newBright = 100 - (y / rect.height) * 100;
    setSaturation(newSat);
    setBrightness(newBright);
    const newColor = hsbToHex(hue, newSat, newBright);
    setTempColor(newColor);
    setTempColorHex(newColor);
  }, [hue]);

  const handleGradientMouseDown = (e) => {
    setIsDraggingGradient(true);
    const rect = e.currentTarget.getBoundingClientRect();
    updateGradientColor(e.clientX, e.clientY, rect);
  };

  const handleGradientMouseMove = React.useCallback((e) => {
    if (!isDraggingGradient) return;
    const picker = document.querySelector('.gradient-picker');
    if (picker) {
      const rect = picker.getBoundingClientRect();
      updateGradientColor(e.clientX, e.clientY, rect);
    }
  }, [isDraggingGradient, updateGradientColor]);

  const handleGradientMouseUp = () => {
    setIsDraggingGradient(false);
  };

  const handleHueChange = (e) => {
    const newHue = parseFloat(e.target.value);
    setHue(newHue);
    const newColor = hsbToHex(newHue, saturation, brightness);
    setTempColor(newColor);
    setTempColorHex(newColor);
  };

  // Add global mouse event listeners for dragging
  React.useEffect(() => {
    if (isDraggingGradient) {
      document.addEventListener('mousemove', handleGradientMouseMove);
      document.addEventListener('mouseup', handleGradientMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleGradientMouseMove);
        document.removeEventListener('mouseup', handleGradientMouseUp);
      };
    }
  }, [isDraggingGradient, handleGradientMouseMove]);

  // Dynamically load Google Fonts for preview
  React.useEffect(() => {
    if (tempFontFamily && isFontPickerOpen) {
      const systemFonts = ['Arial', 'Helvetica', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New', 'Trebuchet MS', 'Comic Sans MS', 'Impact', 'Lucida Sans', 'Tahoma', 'Palatino', 'Garamond', 'Bookman', 'Avant Garde', 'Segoe UI'];

      // Only load if it's not a system font
      if (!systemFonts.includes(tempFontFamily)) {
        const fontName = tempFontFamily.replace(/ /g, '+');
        const linkId = 'google-font-preview';

        // Remove existing font link if any
        const existingLink = document.getElementById(linkId);
        if (existingLink) {
          existingLink.remove();
        }

        // Add new font link
        const link = document.createElement('link');
        link.id = linkId;
        link.rel = 'stylesheet';
        link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@400;500;600;700&display=swap`;
        document.head.appendChild(link);
      }
    }
  }, [tempFontFamily, isFontPickerOpen]);

  const handleColorHexChange = (e) => {
    const hex = e.target.value.toUpperCase();
    setTempColorHex(hex);
    if (/^#[0-9A-F]{6}$/i.test(hex)) {
      const hsb = hexToHsb(hex);
      setHue(hsb.h);
      setSaturation(hsb.s);
      setBrightness(hsb.b);
      setTempColor(hex);
    }
  };

  const handleCopyHex = () => {
    navigator.clipboard.writeText(tempColorHex);
    setShowCopyToast(true);
    setTimeout(() => setShowCopyToast(false), 3000);
  };

  const handleConfirmColor = () => {
    if (/^#[0-9A-F]{6}$/i.test(tempColorHex)) {
      setColorPalette([...colorPalette, tempColorHex]);
      setIsColorPickerOpen(false);
    } else {
      alert('Please enter a valid hex color (e.g., #FF5733)');
    }
  };

  const handleRemoveColor = (index) => {
    setColorPalette(colorPalette.filter((_, i) => i !== index));
  };

  const handleOpenFontPicker = () => {
    setTempFontFamily('Arial');
    setTempFontUsage('Primary');
    setFontSearchQuery('');
    setFontDropdownOpen(false); // Start with dropdown closed
    setIsFontPickerOpen(true);
  };

  const handleFontFamilyChange = (fontName) => {
    setTempFontFamily(fontName);
    setFontDropdownOpen(false); // Close dropdown after selection
  };

  const toggleFontDropdown = () => {
    setFontDropdownOpen(!fontDropdownOpen);
  };

  const handleConfirmFont = () => {
    if (tempFontFamily && tempFontFamily.trim()) {
      const fontEntry = {
        usage: tempFontUsage,
        family: tempFontFamily.trim()
      };

      // Check if a font with the same usage already exists
      const existingIndex = fonts.findIndex(f => f.usage === tempFontUsage);

      if (existingIndex !== -1) {
        // Replace existing font with the same usage
        const updatedFonts = [...fonts];
        updatedFonts[existingIndex] = fontEntry;
        setFonts(updatedFonts);
      } else {
        // Add new font
        setFonts([...fonts, fontEntry]);
      }

      setIsFontPickerOpen(false);
      setFontDropdownOpen(false);
    } else {
      alert('Please select a font');
    }
  };

  const filteredFonts = fontSearchQuery
    ? COMMON_FONTS.filter(font => font.toLowerCase().includes(fontSearchQuery.toLowerCase()))
    : COMMON_FONTS;

  const handleRemoveFont = (index) => {
    setFonts(fonts.filter((_, i) => i !== index));
  };

  const handleEditContent = () => {
    setIsEditingContent(true);
  };

  const handleSaveContent = () => {
    setIsEditingContent(false);
  };

  const handleCancelContentEdit = () => {
    setIsEditingContent(false);
  };

  const handleResetForm = () => {
    // Reset ALL state to start fresh
    setStep(1);
    setCreatives([]);
    setBrandName('');
    setWebsiteUrl('');
    setReferenceAds([]);
    setReferenceAdUrls('');
    setIsProductAd(false);
    setProductImage(null);
    setCountry('');
    setProductAnalysis(null);
    setProductImagePath(null);
    setBrandLogoPath(null);
    setColorPalette([]);
    setFonts([]);
    setContentGuidelines('');
    setIndustryCategory('');
    setBrandDescription('');
    setBrandPersonality([]);
    setKeyCompetitors('');
    setPrimaryCampaignGoal('');
    setAgeGroups([]);
    setGender('All');
    setTargetLocations('');
    setLanguages('');
    setAudienceType([]);
    setOfferType('');
    setOfferDetails('');
    setCreativeObjective('');
    setCreativeFormats(['1080x1080']);
    setAdditionalNotes('');
    setNumberOfVariants(2);
    setError(null);
    // Removed: localStorage.removeItem (no longer using localStorage persistence)
  };

  const handleFetchDetails = async () => {
    setAnalyzing(true);
    setError(null);
    setProgress(0);
    setTargetProgress(0);
    setProgressMessage('Starting...');

    // Clear old logo when starting new analysis
    setBrandLogoPath(null);

    try {
      const formData = new FormData();
      formData.append('brandName', brandName);
      formData.append('websiteUrl', websiteUrl);
      formData.append('country', country);

      // Add product image if uploaded
      if (productImage) {
        formData.append('productImage', productImage);
      }

      // Brand logo will be extracted by backend from website

      // Add uploaded reference ads
      referenceAds.forEach((file) => {
        formData.append(`referenceAds`, file);
      });

      // Add reference URLs if provided
      if (referenceAdUrls.trim()) {
        formData.append('referenceAdUrls', referenceAdUrls);
      }

      const response = await fetch(`${API_URL}/analyze-brand-sse`, {
        method: 'POST',
        body: formData
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n\n');

        // Keep the last incomplete line in buffer
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = JSON.parse(line.substring(6));

              if (data.error) {
                throw new Error(data.error);
              }

              if (data.progress !== undefined) {
                setTargetProgress(data.progress);
                setProgressMessage(data.message || '');
              }

              if (data.complete && data.data) {
                // Set progress to 100% first
                setTargetProgress(100);
                setProgressMessage('Complete!');

                // Wait for animation to reach 100% before proceeding
                setTimeout(() => {
                  // Auto-fill fields from Gemini response
                  const analysis = data.data;
                  if (analysis.industryCategory) setIndustryCategory(analysis.industryCategory);
                  if (analysis.brandDescription) setBrandDescription(analysis.brandDescription);
                  if (analysis.brandPersonality) setBrandPersonality(analysis.brandPersonality);
                  if (analysis.keyCompetitors) setKeyCompetitors(analysis.keyCompetitors.join(', '));
                  if (analysis.primaryCampaignGoal) setPrimaryCampaignGoal(analysis.primaryCampaignGoal);
                  if (analysis.ageGroups) setAgeGroups(analysis.ageGroups);
                  if (analysis.gender) setGender(analysis.gender);
                  if (analysis.targetLocations) setTargetLocations(analysis.targetLocations.join(', '));
                  if (analysis.languages) setLanguages(analysis.languages.join(', '));
                  if (analysis.audienceType) setAudienceType(analysis.audienceType);
                  if (analysis.offerType) setOfferType(analysis.offerType);
                  if (analysis.creativeObjective) setCreativeObjective(analysis.creativeObjective);

                  // Store product analysis and file paths for Step 2
                  if (analysis.productAnalysis) setProductAnalysis(analysis.productAnalysis);
                  if (analysis.productImagePath) setProductImagePath(analysis.productImagePath);
                  // Clear old logo or set new one
                  setBrandLogoPath(analysis.brandLogoPath || null);

                  // Store brand guidelines
                  if (analysis.brandGuidelines) {
                    if (analysis.brandGuidelines.colorPalette) setColorPalette(analysis.brandGuidelines.colorPalette);

                    // Convert fonts object to array format
                    if (analysis.brandGuidelines.fonts) {
                      const fontsData = analysis.brandGuidelines.fonts;
                      const fontsArray = [];

                      if (typeof fontsData === 'object' && !Array.isArray(fontsData)) {
                        // New format: {primary: "...", secondary: "..."}
                        if (fontsData.primary) {
                          fontsArray.push({ usage: 'Primary', family: fontsData.primary });
                        }
                        if (fontsData.secondary) {
                          fontsArray.push({ usage: 'Secondary', family: fontsData.secondary });
                        }
                        setFonts(fontsArray);
                      } else if (Array.isArray(fontsData)) {
                        // Old format or already array - keep as is
                        setFonts(fontsData);
                      }
                    }

                    if (analysis.brandGuidelines.contentGuidelines) setContentGuidelines(analysis.brandGuidelines.contentGuidelines);
                  }

                  setStep(2);
                }, 1000); // Wait 1 second for animation to complete
              }
            } catch (parseError) {
              console.warn('Failed to parse SSE data:', parseError);
            }
          }
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setAnalyzing(false);
      setProgress(0);
      setTargetProgress(0);
      setProgressMessage('');
    }
  };

  const handleGenerateCreatives = async () => {
    setLoading(true);
    setError(null);
    setProgress(0);
    setTargetProgress(0);
    setProgressMessage('Starting creative generation...');

    try {
      const payload = {
        brandName: brandName.trim(),
        websiteUrl,
        country,
        industryCategory,
        brandDescription,
        brandPersonality,
        keyCompetitors: keyCompetitors.split(',').map(c => c.trim()).filter(c => c),
        primaryCampaignGoal,
        ageGroups,
        gender,
        targetLocations: targetLocations.split(',').map(l => l.trim()).filter(l => l),
        languages: languages.split(',').map(l => l.trim()).filter(l => l),
        audienceType,
        offerType,
        offerDetails,
        creativeObjective,
        creativeFormats,
        additionalNotes,
        numberOfVariants,
        // Product analysis data from Step 1
        productAnalysis: productAnalysis,
        productImagePath: productImagePath,
        brandLogoPath: brandLogoPath,
        // Brand Guidelines (colors, fonts, content)
        brandGuidelines: {
          colorPalette: colorPalette,
          fonts: fonts,
          contentGuidelines: contentGuidelines
        },
        // Quality requirements
        requirements: {
          alwaysIncludeLogo: true,
          noFramesOrBorders: true,
          textOverlayLimit: 20, // Meta compliance: max 20% text
          ensureBrandConsistency: true,
          useExactBrandName: true // Don't append suffixes like "meta"
        },
        // Video generation options
        generateVideos: generateVideos,
        videoStyle: generateVideos ? videoStyle : null,
        videoDuration: generateVideos ? parseInt(videoDuration) : null,
        videoQuality: generateVideos ? videoQuality : null
      };

      const response = await fetch(`${API_URL}/generate-creatives-from-brief-sse`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n\n');

        // Keep the last incomplete line in buffer
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = JSON.parse(line.substring(6));

              if (data.error) {
                throw new Error(data.error);
              }

              if (data.progress !== undefined) {
                setTargetProgress(data.progress);
                setProgressMessage(data.message || '');
              }

              if (data.complete && data.data) {
                // Set progress to 100% first
                setTargetProgress(100);
                setProgressMessage('Complete!');

                // Wait for animation to reach 100% before proceeding
                setTimeout(() => {
                  // Handle video or image results
                  if (data.data.type === 'video') {
                    setGeneratedVideo(data.data.video);
                    setResultType('video');
                    setCreatives([]);
                  } else {
                    setCreatives(data.data.creatives || []);
                    setResultType('images');
                    setGeneratedVideo(null);
                  }
                  setCurrentSessionId(data.data.sessionId || null); // Capture session ID for improvements
                  setStep(3);
                }, 1000); // Wait 1 second for animation to complete
              }
            } catch (parseError) {
              console.warn('Failed to parse SSE data:', parseError);
            }
          }
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setProgress(0);
      setTargetProgress(0);
      setProgressMessage('');
    }
  };

  const handleDownload = async (imageUrl, filename) => {
    try {
      const response = await fetch(getImageUrl(imageUrl));
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
      alert('Failed to download image');
    }
  };

  /**
   * Analyze creative image for text elements
   * Called when user clicks "Improve" button
   */
  const handleAnalyzeCreative = async (creative, index) => {
    try {
      setAnalyzingText(true);
      setAnalysisError(null);
      setTextMetadata(null);
      setSelectedCreativeForImprovement(creative);
      setImprovingCreativeIndex(index);
      setShowImprovementModal(true);

      console.log('🔍 Analyzing creative for text elements...');

      const response = await fetch(`${API_URL}/analyze-creative`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          imageUrl: creative.imageUrl
        })
      });

      const data = await response.json();

      if (data.success) {
        const textElements = data.data?.textElements || data.textElements || [];
        const tokenUsage = data.data?.tokenUsage || data.tokenUsage || {};
        setTextMetadata({
          textElements,
          tokenUsage
        });
        console.log(`✅ Found ${textElements.length} text elements`);
      } else {
        throw new Error(data.error || 'Analysis failed');
      }

    } catch (error) {
      console.error('❌ Analysis error:', error);
      setAnalysisError(`Analysis failed: ${error.message}`);
      // Still allow freeform improvement
      setTextMetadata({ textElements: [], tokenUsage: {} });
    } finally {
      setAnalyzingText(false);
    }
  };

  /**
   * Apply improvements and regenerate creative
   */
  const handleApplyImprovements = async () => {
    try {
      setImprovementLoading(true);
      setImprovementError(null);
      setImprovementSuccess(false);

      // Build text changes array from edited values
      const textChanges = [];
      if (textMetadata && textMetadata.textElements) {
        textMetadata.textElements.forEach((element, textIndex) => {
          const newText = textEdits[textIndex];
          if (newText !== undefined && newText !== element.text) {
            textChanges.push({
              originalText: element.text,
              newText: newText
            });
          }
        });
      }

      // Validate we have some changes
      if (textChanges.length === 0 && !freeformInstructions.trim()) {
        setImprovementError('No changes specified. Edit text or add freeform instructions.');
        setImprovementLoading(false);
        return;
      }

      console.log('🎨 Applying improvements...');
      console.log(`   Text changes: ${textChanges.length}`);
      console.log(`   Freeform: ${freeformInstructions ? 'Yes' : 'No'}`);

      const payload = {
        originalCreative: selectedCreativeForImprovement,
        textChanges,
        freeformInstructions,
        sessionId: currentSessionId,
        brief: {
          brandName,
          campaignGoal: primaryCampaignGoal,
          targetAudience: audienceType
        }
      };

      const response = await fetch(`${API_URL}/improve-creative`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.success) {
        console.log('✅ Creative improved successfully');
        console.log(`   Saved to database: ID ${data.creative.id}`);
        console.log(`   GCS URL: ${data.creative.imageUrl}`);

        // Create improved creative object matching the format
        const improvedCreative = {
          id: data.creative.id,
          variantNumber: data.creative.variantNumber,
          format: data.creative.format,
          style: data.creative.style,
          imageUrl: data.creative.imageUrl,
          width: selectedCreativeForImprovement.width,
          height: selectedCreativeForImprovement.height,
          fileSize: selectedCreativeForImprovement.fileSize,
          isImproved: true  // Flag to identify improved versions
        };

        // Add to creatives array
        setCreatives(prev => [...prev, improvedCreative]);

        setImprovementSuccess(true);

        // Close modal after 2 seconds
        setTimeout(() => {
          handleCloseImprovementModal();
        }, 2000);
      } else {
        throw new Error(data.error || 'Improvement failed');
      }

    } catch (error) {
      console.error('❌ Improvement error:', error);
      setImprovementError(`Improvement failed: ${error.message}`);
    } finally {
      setImprovementLoading(false);
    }
  };

  /**
   * Close improvement modal and reset states
   */
  const handleCloseImprovementModal = () => {
    setShowImprovementModal(false);
    setSelectedCreativeForImprovement(null);
    setImprovingCreativeIndex(null);
    setTextMetadata(null);
    setTextEdits({});
    setFreeformInstructions('');
    setAnalysisError(null);
    setImprovementError(null);
    setImprovementSuccess(false);
  };

  const toggleArrayValue = (array, setter, value) => {
    if (array.includes(value)) {
      setter(array.filter(v => v !== value));
    } else {
      setter([...array, value]);
    }
  };

  function StepItem({ step, label, active }) {
    return (
      <li className="flex flex-col items-center gap-1 relative">
        <div
          className={`h-7 w-7 rounded-full flex items-center justify-center text-xs font-medium
          ${active ? "text-white bg-blue-600" : "bg-gray-50 text-gray-400"}`}
        >
          {step}
        </div>
        <span
          className={`${
            active ? "text-sm font-medium text-blue-600" : "text-sm text-gray-500"
          }`}
        >
          {label}
        </span>
      </li>
    );
  }

  return (
    <div className="creative-brief-container">
      {(analyzing || loading) && progress > 0 && (
        <ProgressLoader progress={progress} message={progressMessage} />
      )}

      {/* <div className="right-top-absolute">
        <img className="inline-flex 2xl:max-w-80 max-w-44" src="/upside_right.svg" alt="Ultra RightTop" />
      </div>

      <div className="left-bottom-absolute">
        <img className="inline-flex 2xl:max-w-72 max-w-40" src="/downside-left.svg" alt="Ultra RightTop" />
      </div> */}

      {/* <header className="brief-header">
        <div className="header-title">
          <div className="title-group">
            <div className="main-title">
               <img src="/iris_logo.svg" alt="Ultra Iris Logo" className="ultra-iris-logo" />
            </div>
            <p className="header-subtitle">Professional Ad Creative Generator</p>
          </div>
        </div>
        <button
          className="history-nav-button"
          onClick={() => navigate('/creative-history')}
          title="View Creative History"
        >
          <History size={20} />
          <span>History</span>
        </button>
      </header> */}
      
      

      {error && (
        <div className="error-message">
          <p>❌ {error}</p>
        </div>
      )}

      <div className="flex relative">

        <Sidebar onResetForm={handleResetForm}/>

        <main className="bg-white flex-1 px-3 pt-10 pb-3">

          <ul className="flex items-center justify-center gap-10 step-items mb-5">
            <StepItem
              step={1}
              label="Brand Information"
              active={step === 1}
            />
            <StepItem
              step={2}
              label="Creative Preferences"
              active={step === 2}
            />

            <StepItem
              step={3}
              label="Generate Ads"
              active={step === 3}
            />
          </ul>
          
          <div className="main-layout p-5 py-10">
            <div className="w-full md:w-[75%] lg:w-[65%] mx-auto shadow bg-white rounded-xl p-6 px-6">

              {/* Step 1: Mandatory Fields */}
              {step === 1 && (
                <div className="brief-form">
                  <h2 className="form-section-title">Step 1: Brand Information</h2>

                  <div className="grid grid-cols-10 gap-3 form-field">
                    <label className='col-span-3'>Brand Name<span className="required">*</span></label>
                    <div className="col-span-7">
                      <input
                        type="text"
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                        placeholder="Enter your brand name"
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-10 gap-3 form-field">
                    <label className='col-span-3'>Website / App Link<span className="required">*</span></label>
                    <div className="col-span-7">
                      <input
                        type="url"
                        value={websiteUrl}
                        onChange={(e) => setWebsiteUrl(e.target.value)}
                        placeholder="https://www.yourbrand.com"
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-10 gap-3 form-field">
                    <label className='col-span-3'>Reference Ads (Upload Files)<span className="required">*</span></label>
                    <div className="col-span-7">
                      <input
                        type="file"
                        onChange={handleFileUpload}
                        multiple
                        accept="image/*"
                      />
                      {referenceAds.length > 0 && (
                        <small className="file-count">{referenceAds.length} file(s) selected</small>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-10 gap-3 form-field" style={{ display: 'none' }}>
                    <label className='col-span-3'>Reference Ads (URLs)</label>
                    <div className="col-span-7">
                      <textarea
                        value={referenceAdUrls}
                        onChange={(e) => setReferenceAdUrls(e.target.value)}
                        placeholder="Paste image URLs or Meta ads library links here, one per line&#10;https://example.com/ad1.jpg&#10;https://www.facebook.com/ads/library/?id=5183792265178488"
                        rows="3"
                      />
                      <small className="field-hint">Meta ads library links will be analyzed to extract creative style and elements. Provide either uploaded files or URLs (or both)</small>
                    </div>
                  </div>

                  <div className="grid grid-cols-10 gap-3 form-field">
                    <label className='col-span-3'>Country<span className="required">*</span></label>
                    <div className="col-span-7">
                      <select value={country} onChange={(e) => setCountry(e.target.value)} required>
                        <option value="">Select country</option>
                        {COUNTRIES.map(c => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="form-field">
                    <label className="switch-label">
                      <span className="switch-text">Is this a Product Ad?</span>
                      <div className="switch-container">
                        <input
                          type="checkbox"
                          checked={isProductAd}
                          onChange={(e) => setIsProductAd(e.target.checked)}
                          className="switch-checkbox"
                          id="product-ad-switch"
                        />
                        <label htmlFor="product-ad-switch" className="switch-slider"></label>
                      </div>
                    </label>
                    <small className="field-hint">Enable if you have a specific product image to upload for accurate replication</small>
                  </div>

                  {isProductAd && (
                    <div className="product-ad-section">
                      <div className="section-header">
                        <span className="section-icon">📦</span>
                        <h3 className="section-title">Product Image</h3>
                      </div>

                      <div className="grid grid-cols-10 gap-3 form-field">
                        <label className='col-span-3'>Product Image (Optional)</label>
                        <div className="col-span-7">
                          <input
                            type="file"
                            onChange={handleProductImageUpload}
                            accept="image/*"
                          />
                          {productImage && (
                            <small className="file-count">✓ {productImage.name}</small>
                          )}
                          <small className="field-hint">
                            <strong>📸 Upload specific product image</strong> - AI will analyze and preserve exact product details (color, style, packaging, specifications)
                          </small>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="button-group">
                    <button
                      className="primary-button"
                      onClick={handleFetchDetails}
                      disabled={!brandName || !websiteUrl || (referenceAds.length === 0 && !referenceAdUrls.trim()) || !country || analyzing}
                    >
                      {analyzing ? 'Analyzing Brand...' : 'Fetch Details →'}
                    </button>
                  </div>
                </div>
              )}

              {/* Step 2: Auto-filled & Editable Fields */}
              {step === 2 && (
                <div className="brief-form">
                  <h2 className="form-section-title">Step 2: Campaign Details</h2>
                  <p className="form-subtitle">Review and edit the auto-filled information below</p>

                  {/* Brand Guidelines Section - Compact Design */}
                  <div className="form-section brand-guidelines-compact">
                    <div className="guidelines-header-compact" onClick={() => setGuidelinesExpanded(!guidelinesExpanded)}>
                      <div className="guidelines-title-row">
                        <span className="guidelines-icon">🎨</span>
                        <h3 className="guidelines-title">Brand Guidelines</h3>
                      </div>
                      <span className="accordion-arrow">{guidelinesExpanded ? '▲' : '▼'}</span>
                    </div>

                    {guidelinesExpanded && (
                      <div className="guidelines-content-compact">
                        {/* Tabs */}
                        <div className="guidelines-tabs-compact">
                          <button
                            className={`tab-btn-compact ${activeGuidelineTab === 'design' ? 'active' : ''}`}
                            onClick={() => setActiveGuidelineTab('design')}
                            type="button"
                          >
                            Design
                          </button>
                          <button
                            className={`tab-btn-compact ${activeGuidelineTab === 'content' ? 'active' : ''}`}
                            onClick={() => setActiveGuidelineTab('content')}
                            type="button"
                          >
                            Content
                          </button>
                        </div>

                        {/* Design Tab */}
                        {activeGuidelineTab === 'design' && (
                          <div className="tab-panel-compact">
                            {/* Logo Section */}
                            <div className="guidelines-section-compact">
                              <h4 className="section-label-compact">Logos</h4>
                              <div className="logos-row-compact">
                            {brandLogoPath ? (
                              <div className="logo-box-compact has-logo">
                                <img
                                  src={`${API_URL}${brandLogoPath}?t=${Date.now()}`}
                                  alt="Brand Logo"
                                  className="logo-img-compact"
                                />
                              </div>
                            ) : (
                              <div className="logo-box-compact empty" onClick={() => document.getElementById('logo-upload-compact').click()}>
                                <span className="logo-placeholder-text">No logo</span>
                              </div>
                            )}

                            <div className="logo-box-compact add-logo" onClick={() => document.getElementById('logo-upload-compact').click()}>
                              <span className="add-icon-compact">+</span>
                              <span className="add-text-compact">Add logo</span>
                            </div>

                            <input
                              id="logo-upload-compact"
                              type="file"
                              onChange={handleBrandLogoUpload}
                              accept="image/png,image/jpeg,image/jpg,image/webp"
                              style={{ display: 'none' }}
                            />
                          </div>
                        </div>

                        {/* Colors Section */}
                        <div className="guidelines-section-compact">
                          <div className="section-header-row-compact">
                            <h4 className="section-label-compact">Colors <span className="info-icon-compact">ⓘ</span></h4>
                          </div>
                          <div className="color-palette-label-compact">
                            Color palette <span className="edit-icon-compact">✎</span>
                          </div>
                          <div className="colors-row-compact">
                            <div className="color-circle-add-compact" onClick={handleOpenColorPicker}>
                              <span className="plus-compact">+</span>
                            </div>
                            {colorPalette.map((color, index) => (
                              <div key={index} className="color-item-compact">
                                <div className="color-circle-compact" style={{ backgroundColor: color }}>
                                  <button
                                    className="remove-x-compact"
                                    onClick={() => handleRemoveColor(index)}
                                    type="button"
                                  >
                                    ×
                                  </button>
                                </div>
                                <span className="color-code-compact">{color}</span>
                              </div>
                            ))}
                          </div>
                          <button className="add-palette-button-compact" onClick={handleOpenColorPicker} type="button">
                           <span className="plus-compact">+</span> Add Palette 
                          </button>
                        </div>

                        {/* Fonts Section */}
                        <div className="guidelines-section-compact">
                          <div className="section-header-row-compact">
                            <h4 className="section-label-compact">Fonts <span className="info-icon-compact">ⓘ</span></h4>
                            <span className="uploaded-fonts-link">Uploaded Fonts</span>
                          </div>
                          <div className="fonts-list-compact">
                            {fonts.map((fontEntry, index) => (
                              <div key={index} className="font-item-compact-wrapper">
                                <div className="font-item-compact" style={{ fontFamily: fontEntry.family || fontEntry }}>
                                  <div className="font-name-display-compact">{fontEntry.family || fontEntry} ({fontEntry.usage || 'Primary'})</div>
                                </div>
                                <button
                                  className="font-remove-compact"
                                  onClick={() => handleRemoveFont(index)}
                                  type="button"
                                  title="Remove font"
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                          </div>
                          <button className="add-font-button-compact" onClick={handleOpenFontPicker} type="button">
                            <span className="plus-compact">+</span> Add Font Style 
                          </button>
                        </div>
                          </div>
                        )}

                        {/* Content Tab */}
                        {activeGuidelineTab === 'content' && (
                          <div className="tab-panel-compact">
                            {/* Content Guidelines Section */}
                            <div className="guidelines-section-compact">
                              <div className="section-header-row-compact">
                                <h4 className="section-label-compact">Content Guidelines</h4>
                                {!isEditingContent && (
                                  <button className="edit-link-compact" onClick={handleEditContent} type="button">
                                    Edit
                                  </button>
                                )}
                              </div>
                              {!isEditingContent ? (
                                <div className="content-preview-compact">
                                  {contentGuidelines || <em className="content-empty-compact">No content guidelines set yet.</em>}
                                </div>
                              ) : (
                                <>
                                  <textarea
                                    className="content-textarea-compact"
                                    value={contentGuidelines}
                                    onChange={(e) => setContentGuidelines(e.target.value)}
                                    placeholder="Define writing style, tone, words to avoid, required disclaimers..."
                                    rows="6"
                                  />
                                  <div className="content-actions-compact">
                                    <button className="save-btn-compact" onClick={handleSaveContent} type="button">
                                      Save
                                    </button>
                                    <button className="cancel-btn-compact" onClick={handleCancelContentEdit} type="button">
                                      Cancel
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Brand Information Section */}
                  <div className="form-section">
                    <h3 className="section-header">📋 Brand Information</h3>
                    
                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Industry / Category</label>
                      <div className="col-span-7">
                        <select value={industryCategory} onChange={(e) => setIndustryCategory(e.target.value)}>
                          <option value="">Select industry</option>
                          {INDUSTRIES.map(ind => (
                            <option key={ind} value={ind}>{ind}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Brand Description</label>
                      <div className="col-span-7">
                        <textarea
                          value={brandDescription}
                          onChange={(e) => setBrandDescription(e.target.value)}
                          placeholder="Describe your brand, offering, and value proposition..."
                          rows="3"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Brand Personality</label>
                      <div className="col-span-7">
                        <div className="checkbox-grid">
                          {BRAND_PERSONALITIES.map(personality => (
                            <label key={personality} className="checkbox-label">
                              <input
                                type="checkbox"
                                checked={brandPersonality.includes(personality)}
                                onChange={() => toggleArrayValue(brandPersonality, setBrandPersonality, personality)}
                              />
                              {personality}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Key Competitors<span className="required">*</span>
                        <small className="field-hint">Separate multiple competitors with commas</small>
                      </label>
                      <div className="col-span-7">
                        <input
                          type="text"
                          value={keyCompetitors}
                          onChange={(e) => setKeyCompetitors(e.target.value)}
                          placeholder="Competitor 1, Competitor 2, Competitor 3"
                          required
                        />
                        
                      </div>
                    </div>
                  </div>

                  {/* Campaign Goals Section */}
                  <div className="form-section">
                    <h3 className="section-header">🎯 Campaign Goals</h3>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Primary Campaign Goal<span className="required">*</span></label>
                      <div className="col-span-7">
                        <select value={primaryCampaignGoal} onChange={(e) => setPrimaryCampaignGoal(e.target.value)} required>
                          <option value="">Select campaign goal</option>
                          {CAMPAIGN_GOALS.map(goal => (
                            <option key={goal} value={goal}>{goal}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Creative Objective<span className="required">*</span></label>
                      <div className="col-span-7">
                        <select value={creativeObjective} onChange={(e) => setCreativeObjective(e.target.value)} required>
                          <option value="">Select creative objective</option>
                          {CREATIVE_OBJECTIVES.map(obj => (
                            <option key={obj} value={obj}>{obj}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Target Audience Section */}
                  <div className="form-section">
                    <h3 className="section-header">👥 Target Audience</h3>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Age Group <span className="required">*</span></label>
                      <div className="col-span-7">
                        <div className="checkbox-grid">
                          {AGE_GROUPS.map(age => (
                            <label key={age} className="checkbox-label">
                              <input
                                type="checkbox"
                                checked={ageGroups.includes(age)}
                                onChange={() => toggleArrayValue(ageGroups, setAgeGroups, age)}
                              />
                              {age} Years
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Gender<span className="required">*</span></label>
                      <div className="col-span-7">
                        <select value={gender} onChange={(e) => setGender(e.target.value)} required>
                          {GENDERS.map(g => (
                            <option key={g} value={g}>{g}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Target Location<span className="required">*</span>
                        <small className="field-hint">Separate multiple locations with commas</small>
                      </label>
                      <div className="col-span-7">
                        <input
                          type="text"
                          value={targetLocations}
                          onChange={(e) => setTargetLocations(e.target.value)}
                          placeholder="Mumbai, Delhi, Bangalore"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Languages <span className="required">*</span>
                        <small className="field-hint">Separate multiple languages with commas</small>
                      </label>
                      <div className="col-span-7">
                        <input
                          type="text"
                          value={languages}
                          onChange={(e) => setLanguages(e.target.value)}
                          placeholder="English, Hindi"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Audience Type <span className="required">*</span></label>
                      <div className="col-span-7">
                        <div className="checkbox-grid">
                          {AUDIENCE_TYPES.map(type => (
                            <label key={type} className="checkbox-label">
                              <input
                                type="checkbox"
                                checked={audienceType.includes(type)}
                                onChange={() => toggleArrayValue(audienceType, setAudienceType, type)}
                              />
                              {type}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Offer & Creative Requirements Section */}
                  <div className="form-section">
                    <h3 className="section-header">💰 Offer & Creative Requirements</h3>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Offer Type<span className="required">*</span></label>
                      <div className="col-span-7">
                        <select value={offerType} onChange={(e) => setOfferType(e.target.value)} required>
                          <option value="">Select offer type</option>
                          {OFFER_TYPES.map(offer => (
                            <option key={offer} value={offer}>{offer}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Offer Details</label>
                      <div className="col-span-7">
                        <input
                          type="text"
                          value={offerDetails}
                          onChange={(e) => setOfferDetails(e.target.value)}
                          placeholder="e.g., Flat 30% off on all eyewear"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Required Creative Formats<span className="required">*</span></label>
                      <div className="col-span-7">
                        <div className="checkbox-grid">
                        {CREATIVE_FORMATS.map(format => (
                          <label key={format.value} className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={creativeFormats.includes(format.value)}
                              onChange={() => toggleArrayValue(creativeFormats, setCreativeFormats, format.value)}
                            />
                            {format.label}
                          </label>
                        ))}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Number of Variants per Format<span className="required">*</span>
                        <small className="field-hint">How many style variations to generate for each selected format</small>
                      </label>
                      <div className="col-span-7">
                        <input
                          type="number"
                          min="1"
                          max="5"
                          value={numberOfVariants}
                          onChange={(e) => setNumberOfVariants(parseInt(e.target.value))}
                          required
                        />
                      </div>
                      
                    </div>
                  </div>

                  {/* Additional Notes Section */}
                  <div className="form-section">
                    <h3 className="section-header">📝 Additional Notes</h3>
                    <div className="grid grid-cols-10 gap-3 form-field">
                      <label className='col-span-3'>Additional Notes</label>
                      <div className="col-span-7">
                        <textarea
                          value={additionalNotes}
                          onChange={(e) => setAdditionalNotes(e.target.value)}
                          placeholder="Any special instructions, do's and don'ts for the creatives..."
                          rows="4"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Color Picker Modal - Compact */}
                  {isColorPickerOpen && (
                    <div className="modal-overlay-compact" onClick={() => setIsColorPickerOpen(false)}>
                      <div className="color-picker-modal-compact" onClick={(e) => e.stopPropagation()}>
                        {/* Header with Hex and Close */}
                        <div className="color-modal-header-compact">
                          <div className="hex-display-compact">
                            <span className="hex-text-compact">{tempColorHex}</span>
                            <button className="edit-hex-icon-compact" type="button">✎</button>
                          </div>
                          <button className="close-modal-compact" onClick={() => setIsColorPickerOpen(false)} type="button">
                            ×
                          </button>
                        </div>

                        {/* 2D Gradient Picker */}
                        <div
                          className="gradient-picker-compact"
                          onMouseDown={handleGradientMouseDown}
                          style={{
                            background: `linear-gradient(to bottom, transparent, black), linear-gradient(to right, white, hsl(${hue}, 100%, 50%))`
                          }}
                        >
                          <div
                            className="gradient-cursor-compact"
                            style={{
                              left: `${saturation}%`,
                              top: `${100 - brightness}%`
                            }}
                          />
                        </div>

                        {/* Hue Slider */}
                        <input
                          type="range"
                          min="0"
                          max="360"
                          value={hue}
                          onChange={handleHueChange}
                          className="hue-slider-compact"
                        />

                        {/* Bottom Section: Color Preview + Hex Input + Copy */}
                        <div className="color-input-row-compact">
                          <div
                            className="color-preview-square-compact"
                            style={{ backgroundColor: tempColor }}
                          />
                          <input
                            type="text"
                            value={tempColorHex}
                            onChange={handleColorHexChange}
                            className="hex-input-compact"
                            maxLength="7"
                          />
                          <button
                            className="copy-icon-button-compact"
                            onClick={handleCopyHex}
                            type="button"
                            title="Copy color code"
                          >
                            📋
                          </button>
                        </div>

                        {/* Apply Button */}
                        <button className="apply-color-button-compact" onClick={handleConfirmColor} type="button">
                          Apply
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Copy Toast Notification */}
                  {showCopyToast && (
                    <div className="copy-toast">
                      <span className="toast-icon">✓</span>
                      <span className="toast-text">Color copied to clipboard</span>
                    </div>
                  )}

                  {/* Font Picker Modal */}
                  {isFontPickerOpen && (
                    <div className="modal-overlay" onClick={() => setIsFontPickerOpen(false)}>
                      <div className="modal-content font-picker-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                          <h3>Add Font Style</h3>
                          <button className="modal-close" onClick={() => setIsFontPickerOpen(false)}>×</button>
                        </div>
                        <div className="modal-body">
                          {/* Font Usage & Family Dropdowns */}
                          <div className="font-selectors-row">
                            <div className="font-usage-selector">
                              <select
                                value={tempFontUsage}
                                onChange={(e) => {
                                  setTempFontUsage(e.target.value);
                                  setFontDropdownOpen(false); // Close dropdown when changing usage type
                                }}
                                className="font-usage-select"
                              >
                                {FONT_USAGE_TYPES.map(usage => (
                                  <option key={usage} value={usage}>{usage}</option>
                                ))}
                              </select>
                            </div>
                            <div className="font-family-selector">
                              <div className="font-dropdown">
                                <input
                                  type="text"
                                  value={tempFontFamily}
                                  readOnly
                                  className="font-dropdown-input"
                                  onClick={toggleFontDropdown}
                                />
                                {/* Search Input */}
                                {fontDropdownOpen && (
                                <div className="font-search-dropdown">
                                  <input
                                    type="text"
                                    placeholder="Search fonts"
                                    value={fontSearchQuery}
                                    onChange={(e) => setFontSearchQuery(e.target.value)}
                                    className="font-search-input"
                                  />
                                  <div className="font-list">
                                    <div className="font-list-header">Google fonts</div>
                                    {filteredFonts.map(font => (
                                      <div
                                        key={font}
                                        className="font-list-item"
                                        onClick={() => handleFontFamilyChange(font)}
                                        style={{ fontFamily: font }}
                                      >
                                        {font}
                                        {tempFontFamily === font && <span className="font-selected-check">✓</span>}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Typography Preview */}
                          <div className="typography-preview">
                            <h4>Typography sample</h4>
                            <div className="typography-sample" style={{ fontFamily: tempFontFamily }}>
                              The quick brown fox jumps over the lazy dog
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button className="apply-button" onClick={handleConfirmFont}>Apply</button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Temporarily hidden - Video Generation Options */}
                  {false && (
                  <div className="form-field" style={{ marginTop: '32px', paddingTop: '32px', borderTop: '1px solid #e5e7eb' }}>
                    <div style={{ marginBottom: '16px' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '16px',
                        fontWeight: '600',
                        gap: '8px',
                        cursor: 'pointer'
                      }}>
                        <input
                          type="checkbox"
                          checked={generateVideos}
                          onChange={(e) => setGenerateVideos(e.target.checked)}
                          style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                        />
                        <FiVideo size={20} />
                        Generate Video Ad (instead of static images)
                      </label>
                      <p style={{
                        fontSize: '13px',
                        color: '#6b7280',
                        marginTop: '6px',
                        marginLeft: '26px'
                      }}>
                        Create a short-form video ad using Veo 3.1 AI. This will replace static image generation.
                      </p>

                      {/* Feature highlight: Image-to-Video Technology */}
                      <div style={{
                        marginTop: '12px',
                        marginLeft: '26px',
                        padding: '12px',
                        backgroundColor: '#DBEAFE',
                        borderLeft: '3px solid #3B82F6',
                        borderRadius: '4px'
                      }}>
                        <p style={{
                          fontSize: '12px',
                          color: '#1E40AF',
                          margin: 0,
                          lineHeight: '1.5'
                        }}>
                          <strong>✨ Image-to-Video Technology:</strong> Your uploaded product image will be animated into a professional video ad using Veo 3.1.
                          The video will feature your exact product as the starting frame, ensuring accurate brand representation.
                        </p>
                      </div>
                    </div>

                    {generateVideos && (
                      <div style={{
                        marginLeft: '26px',
                        marginTop: '16px',
                        padding: '16px',
                        backgroundColor: '#f9fafb',
                        borderRadius: '8px'
                      }}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                          <div>
                            <label style={{ fontSize: '14px', fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                              Video Style
                            </label>
                            <select
                              value={videoStyle}
                              onChange={(e) => setVideoStyle(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #d1d5db',
                                fontSize: '14px'
                              }}
                            >
                              <option value="simple-ugc">Simple UGC</option>
                              <option value="minimal">Minimal</option>
                              <option value="unboxing">Unboxing</option>
                              <option value="customer-reviews">Customer Reviews</option>
                              <option value="viral-chaos">Viral Chaos</option>
                              <option value="luxury">Luxury</option>
                              <option value="product-story">Product Story</option>
                              <option value="cozy-morning">Cozy Morning</option>
                              <option value="red-carpet">Red Carpet</option>
                              <option value="elegant-minimal">Elegant Minimal</option>
                            </select>
                          </div>

                          <div>
                            <label style={{ fontSize: '14px', fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                              Duration
                            </label>
                            <select
                              value={videoDuration}
                              onChange={(e) => setVideoDuration(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #d1d5db',
                                fontSize: '14px'
                              }}
                            >
                              <option value="4">4 seconds</option>
                              <option value="6">6 seconds</option>
                              <option value="8">8 seconds</option>
                            </select>
                          </div>

                          <div>
                            <label style={{ fontSize: '14px', fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                              Quality
                            </label>
                            <select
                              value={videoQuality}
                              onChange={(e) => setVideoQuality(e.target.value)}
                              style={{
                                width: '100%',
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #d1d5db',
                                fontSize: '14px'
                              }}
                            >
                              <option value="720p">720p HD</option>
                              <option value="1080p">1080p Full HD</option>
                              <option value="4k">4K Ultra HD</option>
                            </select>
                            <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>
                              {videoQuality !== '720p' && videoDuration !== '8' && '1080p/4K only for 8s videos'}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  )}

                  <div className="button-group">
                    <button
                      type="button"
                      className="secondary-button"
                      onClick={() => setStep(1)}
                    >
                      ← Back
                    </button>
                    <button
                      type="button"
                      className="primary-button"
                      onClick={handleGenerateCreatives}
                      disabled={loading || !keyCompetitors || !primaryCampaignGoal || ageGroups.length === 0 || !gender || !targetLocations || !languages || audienceType.length === 0 || !offerType || !creativeObjective || creativeFormats.length === 0}
                    >
                      {loading ? (generateVideos ? 'Generating Video...' : 'Generating Creatives...') : (generateVideos ? 'Generate Video 🎬' : 'Generate Creatives 🎨')}
                    </button>
                  </div>
                </div>
              )}

              {/* Step 3: Results */}
              {step === 3 && (resultType === 'images' ? creatives.length > 0 : generatedVideo) && (
                <div className="results-container">
                  {resultType === 'video' ? (
                    /* Video Results */
                    <>
                      <p className="results-subtitle">Your AI-generated video ad is ready!</p>

                      <div style={{
                        maxWidth: '800px',
                        margin: '0 auto',
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                      }}>
                        <div className="modal-image-header" style={{ marginBottom: '16px' }}>
                          <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <FiVideo size={20} />
                            Generated Video
                          </h4>
                          <div className="image-actions">
                            <a
                              href={generatedVideo.videoUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="action-button"
                              title="View"
                            >
                              <FiEye size={16} />
                            </a>
                            <a
                              href={generatedVideo.videoUrl}
                              download={`${brandName}-video-ad.mp4`}
                              className="action-button"
                              title="Download"
                            >
                              <HiDownload size={16} />
                            </a>
                          </div>
                        </div>

                        <div style={{
                          position: 'relative',
                          width: '100%',
                          maxWidth: '400px',
                          margin: '0 auto',
                          aspectRatio: '9/16',
                          backgroundColor: '#000',
                          borderRadius: '8px',
                          overflow: 'hidden'
                        }}>
                          <video
                            controls
                            preload="metadata"
                            style={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%) scale(1.25)',
                              width: '100%',
                              height: '100%',
                              display: 'block',
                              objectFit: 'cover'
                            }}
                          >
                            <source src={generatedVideo.videoUrl} type="video/mp4" />
                            Your browser doesn't support HTML5 video.
                          </video>
                        </div>

                        <div className="modal-image-info" style={{ marginTop: '16px', flexWrap: 'wrap' }}>
                          <span className="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-600/20">
                            {generatedVideo.metadata?.duration || '8'}s · {generatedVideo.metadata?.aspectRatio || '9:16'}
                          </span>
                          <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                            {(generatedVideo.metadata?.size / 1024 / 1024).toFixed(2)} MB
                          </span>
                          {generatedVideo.videoStyle && (
                            <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20">
                              Style: {generatedVideo.videoStyle}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    /* Image Results */
                    <>
                      <p className="results-subtitle">Your Meta-compliant ad creatives are ready!</p>
                      <div className="creatives-grid">
                    {creatives.map((creative, index) => (
                      <div key={`${creative.format}-${creative.variantNumber}`} className="modal-image-card">

                        <div className="modal-image-header">
                          <h4>{creative.format}</h4>
                          {creative.imageUrl && (
                            <div className="image-actions">
                              <a
                                href={getImageUrl(creative.imageUrl)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="action-button" title="View"
                              >
                                <FiEye size={16} />
                              </a>
                              <button
                                onClick={() => handleDownload(
                                  creative.imageUrl,
                                  `${brandName}-${creative.format}-${creative.variantNumber}.png`
                                )}
                                className="action-button" title="Download"
                              >
                                <HiDownload size={16} />
                              </button>
                              <button
                                onClick={() => handleAnalyzeCreative(creative, index)}
                                className="action-button improve-button"
                                title="Improve this creative"
                                disabled={improvingCreativeIndex !== null}
                              >
                                ✏️
                              </button>
                            </div>
                          )}
                        </div>

                        {creative.description && (
                          <div className="description">
                            <p>{creative.description}</p>
                          </div>
                        )}

                        {creative.imageUrl && (
                          <div className="modal-image-wrapper">
                            <img
                              src={getImageUrl(creative.imageUrl)}
                              alt={creative.format}
                              loading="lazy"
                            />
                          </div>
                        )}

                        <div className='modal-image-info'>
                           <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">Variant {creative.variantNumber}</span>
                           {creative.isImproved && (
                             <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">✨ Improved</span>
                           )}
                           {/* {creative.fileSize && <span>{(creative.fileSize / 1024).toFixed(2)} KB</span>} */}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* Action Buttons (for both video and image results) */}
              <div className="button-group">
                <button
                  className="secondary-button"
                  onClick={() => setStep(2)}
                >
                  ← Back
                </button>
                <button
                  className="primary-button"
                  onClick={handleResetForm}
                >
                  Create New Campaign
                </button>
              </div>
            </div>
          )}

        </div>
          </div>

          
        </main>

      </div>

      {/* Improvement Modal */}
      {showImprovementModal && (
        <div className="improvement-modal-overlay" onClick={handleCloseImprovementModal}>
          <div className="improvement-modal" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="improvement-modal-header">
              <h3>✏️ Improve Creative</h3>
              <button
                onClick={handleCloseImprovementModal}
                className="modal-close-btn"
                disabled={improvementLoading}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div className="improvement-modal-body">
              {/* Original Creative Preview */}
              {selectedCreativeForImprovement && (
                <div className="original-creative-preview">
                  <h4>Original Creative:</h4>
                  <img
                    src={getImageUrl(selectedCreativeForImprovement.imageUrl)}
                    alt={`${selectedCreativeForImprovement.format} Variant ${selectedCreativeForImprovement.variantNumber}`}
                  />
                  <p className="preview-info">
                    {selectedCreativeForImprovement.format} - Variant {selectedCreativeForImprovement.variantNumber}
                  </p>
                </div>
              )}

              {/* Analysis Loading */}
              {analyzingText && (
                <div className="analysis-loading">
                  <div className="spinner"></div>
                  <p>🔍 Analyzing text elements...</p>
                </div>
              )}

              {/* Analysis Error */}
              {analysisError && (
                <div className="analysis-error">
                  ⚠️ {analysisError}
                  <p className="error-hint">You can still use freeform instructions below.</p>
                </div>
              )}

              {/* Text Editors (if analysis succeeded) */}
              {!analyzingText && textMetadata && textMetadata.textElements.length > 0 && (
                <div className="text-editors-section">
                  <h4>Edit Text Elements:</h4>
                  {textMetadata.textElements.map((element, textIndex) => (
                    <div key={textIndex} className="text-editor-row">
                      <div className="text-editor-labels">
                        <span className="text-position-badge">{element.position}</span>
                        <span className="text-type-badge">{element.type}</span>
                        <span className="text-size-badge">{element.size}</span>
                      </div>
                      <input
                        type="text"
                        value={
                          textEdits[textIndex] !== undefined
                            ? textEdits[textIndex]
                            : element.text
                        }
                        onChange={(e) => {
                          setTextEdits(prev => ({
                            ...prev,
                            [textIndex]: e.target.value
                          }));
                        }}
                        placeholder={element.text}
                        className="text-editor-input"
                        disabled={improvementLoading}
                      />
                    </div>
                  ))}
                  <p className="analysis-tokens">
                    Analysis used {textMetadata.tokenUsage.totalTokens} tokens
                  </p>
                </div>
              )}

              {/* No Text Found Message */}
              {!analyzingText && textMetadata && textMetadata.textElements.length === 0 && (
                <div className="no-text-found">
                  ℹ️ No text detected automatically. Use freeform instructions below to describe your changes.
                </div>
              )}

              {/* Freeform Instructions */}
              {!analyzingText && textMetadata && (
                <div className="freeform-section">
                  <h4>Additional Instructions (Optional):</h4>
                  <textarea
                    value={freeformInstructions}
                    onChange={(e) => setFreeformInstructions(e.target.value)}
                    placeholder="e.g., remove logo in top-right corner, change background to blue gradient, make text bolder..."
                    className="freeform-textarea"
                    rows="4"
                    disabled={improvementLoading}
                  />
                  <p className="freeform-hint">
                    Describe any changes: remove elements, change colors, adjust positioning, etc.
                  </p>
                </div>
              )}

              {/* Improvement Error */}
              {improvementError && (
                <div className="improvement-error">
                  ❌ {improvementError}
                </div>
              )}

              {/* Improvement Success */}
              {improvementSuccess && (
                <div className="improvement-success">
                  ✅ Creative improved successfully! Saved to Creative History.
                  <p>Closing modal...</p>
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="improvement-modal-footer">
              <button
                onClick={handleCloseImprovementModal}
                className="btn-secondary"
                disabled={improvementLoading}
              >
                Cancel
              </button>
              <button
                onClick={handleApplyImprovements}
                className="btn-primary"
                disabled={improvementLoading || analyzingText || improvementSuccess}
              >
                {improvementLoading ? (
                  <>
                    <span className="spinner-small"></span>
                    Improving...
                  </>
                ) : (
                  '🎨 Apply Improvements'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default CreativeBriefForm;
